import { Component, inject, input } from '@angular/core';

import { CamMainRoute, CamRoutes } from '@camelot/menu';
import { TranslatePipe } from '@camelot/translation';
import { ButtonComponent, PictureInfoMessageComponent } from '@camelot/ui';
import { CamAbstractComponent } from '@camelot/utils';

import { CamPermissionsService, Domain, Level, PermissionFeature } from '../../services/permissions.service';
import { CamTranslationUser } from '../../translation.service';

@Component({
  selector: 'cam-guard',
  templateUrl: './guard.component.html',
  styleUrls: ['./guard.component.scss'],
  imports: [ButtonComponent, PictureInfoMessageComponent, TranslatePipe],
})
export class GuardComponent extends CamAbstractComponent {
  level = input.required<Level | string>();

  feature = input.required<PermissionFeature | Domain | string>();

  canDisplayErrorMessage = input(true);

  private readonly _permissionsService = inject(CamPermissionsService);

  constructor() {
    super();
    CamTranslationUser.getInstance();
  }

  public isGuardValid(): boolean {
    return this._permissionsService.canDirectAccess(this.feature(), this.level());
  }

  public goToLogin() {
    this._router.navigateByUrl(CamRoutes.getUrl([CamMainRoute.USERLOGIN]));
  }
}
